"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavButtonContent = exports.NavButtonLabel = exports.NavButtonWrapper = void 0;
const theme_1 = require("@pulse-web-ui/theme");
require("./nav-button.types");
exports.NavButtonWrapper = theme_1.styled.div `
  ${theme_1.mixins.flex({
    alignItems: 'center',
    gap: 4,
    horizontal: false,
})};

  ${theme_1.media.desktop} {
    ${theme_1.mixins.flex({
    alignItems: 'center',
    gap: 10,
    horizontal: true,
})};
  }
`;
exports.NavButtonLabel = theme_1.styled.div `
  ${theme_1.typography.regular14}
  color: ${({ theme }) => theme.colors.text.primary};
`;
exports.NavButtonContent = theme_1.styled.div `
  ${theme_1.mixins.flex({ alignItems: 'center', justifyContent: 'center' })}
  ${theme_1.typography.medium18}
  border-radius: 50%;
  width: 40px;
  height: 40px;
  color: ${({ disabled, theme }) => disabled ? theme.colors.icon.quaternary : theme.colors.icon.secondary};
  background: ${({ isActive, theme }) => isActive
    ? theme.colors.surface.interactive['interactive-tined']
    : theme.colors.neutral[30]};
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  box-sizing: border-box;
  padding: 8px;

  svg {
    width: 24px;
    height: 24px;
  }
`;
